{{#if hasSelectionButtons}}
<td>
	{{#if isSelectable}}
	<input class="js-table-row-select" data-row-id="{{id}}" type="checkbox" {{#if isSelected}}checked{{/if}}></input>
	{{/if}}
</td>
{{/if}}
{{#each this.columns}}
<td {{#if ../isHighlighted}}class="highlight-row"{{/if}}>{{{COLUMN_DATA ../this this.id this.displayMethod}}}</td>
{{/each}}
